import RegisterFormInner from './RegisterFormInner';

/** Demo registration — persisted via Directus (see RegisterFormInner). */
export default function RegisterForm() {
  return <RegisterFormInner />;
}
